import { captureException } from '@sentry/react'
import StackAPI from '../../../lib/StackAPI'
import Publisher from '../types/Publisher'

const ENDPOINT = '/partners/publishers'

const getPublishers = async (): Promise<Publisher[]> => {
  const { get } = StackAPI()
  return await get<{ publishers: Publisher[] }>({ path: ENDPOINT })
    .then(({ data, status }) => (status === 200 ? data.publishers : []))
    .catch((error) => {
      captureException(error)
      return []
    })
}

export default getPublishers
